import { ONBOARDING_STEPS } from '@church/domain'
import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api-context.tsx'
import { useAccess } from '../access/useAccess.ts'
import { orgKeys } from './keys.ts'

/**
 * The first-week checklist, as the viewer should see it: the steps they can
 * act on, done or not. Empty once everything they can do is done — the card
 * then goes away for good, without anyone having to dismiss it.
 */
export function useOnboarding() {
  const api = useApi()
  const access = useAccess()
  const query = useQuery({
    queryKey: orgKeys.onboarding(),
    enabled: access.has('org', 'viewer'),
    queryFn: async () => {
      const { data, error } = await api.api.v1.onboarding.get()
      if (error) throw error
      return data
    },
  })
  const done = new Set(query.data?.steps.filter((s) => s.done).map((s) => s.key) ?? [])
  const steps = ONBOARDING_STEPS.filter((step) => access.allows(step.permission)).map((step) => ({
    ...step,
    done: done.has(step.key),
  }))
  const remaining = steps.filter((step) => !step.done).length
  return {
    steps,
    remaining,
    /** Show the checklist only while the viewer still has something to do. */
    show: query.isSuccess && remaining > 0,
  }
}
